// Place this at the top-level scope of your component/module, or inside a closure if preferred
let previousOption1 = null;

// Call this function inside your onVariantChange logic after `this.currentVariant` is available
function trackPreviousOption1(currentVariant) {
  const wasNoFrame = previousOption1 === "No Frame"; // Save check result for use
  const previousValue = previousOption1; // Store the previous value before updating
  previousOption1 = currentVariant?.option1 || null; // Update tracker
  return {wasNoFrame, previousValue};
}

function isMiniFrameStyle(option1) {
  if (!option1) return false;
  const raw = String(option1).trim();
  if (raw === "Mini") return true;
  let o = raw.toLowerCase().replace(/[-_]+/g, " ").replace(/\s+/g, " ").trim();
  o = o.replace(" anti glare", "").trim();
  return o === "mini frame" || o === "mini";
}

function isMiniSizeHandle(handle) {
  if (!handle) return false;
  return String(handle).trim().toLowerCase() === "mini";
}

function isCollectorSizeValue(value) {
  if (!value) return false;
  const v = String(value).toLowerCase();
  return (
    v.includes("collector") ||
    v.includes('60" x 90"') ||
    v.includes("60 x 90") ||
    v.includes('63" x 42"') ||
    v.includes('42" x 63"')
  );
}

function isCollectorSizeSelected(variantRadios, sizeOptions) {
  if (!sizeOptions?.length) return false;

  for (const option of sizeOptions) {
    const input = option.querySelector('input[type="radio"]');
    if (!input?.checked) continue;

    if (String(option.dataset.valueHandle || "").trim().toLowerCase() === "collector") return true;
    if (isCollectorSizeValue(input.value)) return true;
    if (isCollectorSizeValue(option.querySelector(".name")?.textContent)) return true;
  }

  return false;
}

function isNoFrameVariant(variant) {
  if (!variant) return false;
  return (
    variant.option1 === "No Frame" ||
    variant.option2 === "No Frame" ||
    (variant.title && variant.title.includes("No Frame"))
  );
}

function isNoFrameSelected(variantRadios, variant) {
  if (isNoFrameVariant(variant)) return true;

  if (variantRadios?.querySelector(".noframe-input:checked")) return true;

  const checkedFrameStyle = variantRadios.querySelector('input[type="radio"][name="Frame Style"]:checked');
  if (checkedFrameStyle?.value?.includes("No Frame")) return true;

  const checkedFrameColor = variantRadios.querySelector(
    'input[type="radio"][name="Frame Color"]:checked, input[type="radio"][name="Framing"]:checked',
  );
  if (checkedFrameColor?.value === "No Frame") return true;

  return false;
}

function shouldShowCollectorPremiumAcrylic(variantRadios, sizeOptions, variant) {
  return (
    isCollectorSizeSelected(variantRadios, sizeOptions) && !isNoFrameSelected(variantRadios, variant)
  );
}

function shouldHideGlareForCollectorNoFrame(variantRadios, sizeOptions, variant) {
  return isCollectorSizeSelected(variantRadios, sizeOptions) && isNoFrameSelected(variantRadios, variant);
}

function ensureNonAntiGlareFraming(variantRadios) {
  const group = variantRadios.querySelector('input[type="radio"][name="Frame Color"]')
    ? "Frame Color"
    : variantRadios.querySelector('input[type="radio"][name="Framing"]')
      ? "Framing"
      : null;
  if (!group) return;

  const checked = variantRadios.querySelector(`input[type="radio"][name="${group}"]:checked`);
  if (!checked?.value?.includes("Anti-Glare")) return;

  const baseVal = checked.value.replace(/ Anti-Glare$/, "");
  const baseInput = variantRadios.querySelector(
    `.js-cb-framing-swatch-container input[type="radio"][name="${group}"][value="${baseVal.replace(/"/g, '\\"')}"]`,
  );
  baseInput?.closest(".js-cb-framing-swatch-container")?.querySelector("label")?.click();
}

function updateGlareUiForCollector(variantRadios, showPremiumAcrylic, hideEntireSection = false) {
  const optionGlare = variantRadios?.querySelector(".option-glare");
  if (!optionGlare) return;

  const checkboxBlock = optionGlare.querySelector(".glare-checkbox-block");
  const premiumMessage = optionGlare.querySelector(".premium-acrylic-message");
  const glarePrice = optionGlare.querySelector(".glare-price");
  const antiGlareInput = optionGlare.querySelector('input[name="anti-glare"]');

  if (hideEntireSection) {
    optionGlare.classList.add("hide");
    optionGlare.classList.remove("is-collector-acrylic");
    if (premiumMessage) premiumMessage.hidden = true;
    if (checkboxBlock) checkboxBlock.hidden = true;
    if (glarePrice) glarePrice.hidden = true;
    if (antiGlareInput) {
      antiGlareInput.checked = false;
      antiGlareInput.removeAttribute("checked");
      antiGlareInput.setAttribute("disabled", "true");
    }
    return;
  }

  optionGlare.classList.remove("hide");
  optionGlare.classList.toggle("is-collector-acrylic", showPremiumAcrylic);

  if (checkboxBlock) checkboxBlock.hidden = showPremiumAcrylic;
  if (premiumMessage) premiumMessage.hidden = !showPremiumAcrylic;
  if (glarePrice) glarePrice.hidden = showPremiumAcrylic;

  if (showPremiumAcrylic) {
    if (antiGlareInput) {
      antiGlareInput.checked = false;
      antiGlareInput.removeAttribute("checked");
      antiGlareInput.setAttribute("disabled", "true");
    }
    ensureNonAntiGlareFraming(variantRadios);
  } else if (antiGlareInput) {
    antiGlareInput.removeAttribute("disabled");
  }
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute("aria-expanded", summary.parentNode.hasAttribute("open"));

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute("aria-expanded", !event.currentTarget.closest("details").hasAttribute("open"));
  });

  if (summary.closest("header-drawer, menu-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true,
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + "pauseVideo" + '","args":""}', "*");
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", {bubbles: true});
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) => button.addEventListener("click", this.onButtonClick.bind(this)));
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options["hideElement"] || province_domid);

  Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) => summary.addEventListener("click", this.onSummaryClick.bind(this)));
    this.querySelectorAll("button:not(.localization-selector)").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this)),
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector("button"));
      summaryElement.nextElementSibling.removeEventListener("transitionend", addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);

        // edit there

        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener("transitionend", addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;
    console.log("123123123123");
    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle.querySelectorAll(".submenu-open").forEach((submenu) => {
      submenu.classList.remove("submenu-open");
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute("aria-expanded", false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute("open") && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    if (event.currentTarget.classList.contains("last-back-btn")) return;
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement.querySelector("summary").setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(detailsElement.closest("details[open]"), detailsElement.querySelector("summary"));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset || this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom") ? 1 : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
      );
    document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`);
  };
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener("click", this.hide.bind(this, false));
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (event.pointerType === "mouse" && !event.target.closest("deferred-media, product-model")) this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) {
      const link = this.querySelector("a");
      if (!link) {
        return;
      }

      link.addEventListener("click", (e) => {
        e.preventDefault();
        const modal = document.querySelector(this.getAttribute("data-modal"));
        if (modal) modal.show(link);
      });

      return;
    }

    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(true));

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(content.querySelector("video, model-viewer, iframe"));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == "VIDEO" && deferredElement.getAttribute("autoplay")) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset,
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        }),
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector(".announcement-bar-slider");
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll(".slider-counter__link"));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener("click", this.linkToSlide.bind(this)));
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
      this.reducedMotion.addEventListener("change", () => {
        if (this.slider.getAttribute("data-autoplay") === "true") this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          "click",
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          {once: true},
        );
      });
    }

    if (this.slider.getAttribute("data-autoplay") === "true") this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    if (this.querySelector(".slideshow__autoplay")) {
      this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
      this.sliderAutoplayButton.addEventListener("click", this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add("slider-counter__link--active");
    this.sliderControlButtons[this.currentPage - 1].setAttribute("aria-current", true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = "next") {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === "next" ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = "announcement-bar-slider--fade-in";
    const animationClassOut = "announcement-bar-slider--fade-out";

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === "next" && !isLastSlide) || (button === "previous" && isFirstSlide);
    const direction = shouldMoveNext ? "next" : "previous";

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    const body = document.querySelector("body");
    const bodyOverlay = document.getElementById("body-overlay");
    const custom_dropdown = this.querySelector(".custom-select-dropdown");
    const custom_dropdown_triggers = this.querySelectorAll(".custom-select-dropdown-header");

    this.addEventListener("change", this.onVariantChange);
    this.updateVariantDisplayProperty();
    this.clickOnSizeOption(custom_dropdown, custom_dropdown_triggers, this.onVariantChange);

    // TODO: why is this here?
    // FIXME: Remove this setTimeout and ensure proper initialization flow
    setTimeout(() => {
      this.onVariantChange();
    }, 3000);

    // Custom select dropdowns
    custom_dropdown_triggers.forEach((dropdownTrigger) => {
      dropdownTrigger.addEventListener("click", function (e) {
        e.stopPropagation();
        if (custom_dropdown.classList.contains("active")) {
          custom_dropdown.classList.remove("active");
          bodyOverlay?.classList.remove("show");
          body.classList.remove("no-scroll");
        } else {
          custom_dropdown.classList.add("active");
          if (window.innerWidth < 769) {
            bodyOverlay?.classList.add("show");
            body.classList.add("no-scroll");
          }
        }
      });
    });

    // Add a one-time global click listener to close dropdown when clicking outside
    document.addEventListener("click", function (event) {
      if (custom_dropdown && !custom_dropdown.contains(event.target) && !custom_dropdown.matches(":hover")) {
        custom_dropdown.classList.remove("active");
        if (bodyOverlay != null) bodyOverlay.classList.remove("show");
        body.classList.remove("no-scroll");
      }
    });

    // Initialize sticky scroll button for mobile
    this.initStickyScrollButton();
  }

  updateSizeOptions(selectedOption) {
    console.log(`selectedOption >>> `, selectedOption);
    if (!selectedOption) return;

    const sizeOptions = this.querySelectorAll("#product-select-print-size .input-label-wrap.option-input");

    const selectSizeByHandle = (handle) => {
      const normalizedHandle = String(handle || "").trim().toLowerCase();
      const option = Array.from(sizeOptions).find(
        (opt) => String(opt.dataset.valueHandle || "").trim().toLowerCase() === normalizedHandle,
      );
      if (!option) return;

      const input = option.querySelector('input[type="radio"]');
      if (input) {
        option.classList.remove("disabled");
        input.classList.remove("disabled");
        if (input.parentElement) {
          input.parentElement.classList.remove("disabled");
        }
        input.removeAttribute("disabled");

        if (!input.checked) {
          option.click();
          input.checked = true;
          input.dispatchEvent(new Event("change", {bubbles: true}));
        }

        // Always trigger click to ensure UI unlocks (like removing "no-size-selected-yet" and enabling Add To Cart)
        // Since we may have pointerEvents='none' on the wrapper, we temporarily enable it on the option
        const prevPointerEvents = option.style.pointerEvents;
        option.style.pointerEvents = "auto";
        option.click();
        option.style.pointerEvents = prevPointerEvents;

        // Explicitly unlock the Add To Cart button if the class exists just in case
        const formId = option.getAttribute("data-add-to-cart-form");
        const addToCartButton = formId
          ? document.getElementById(formId)
          : this.closest("product-info")?.querySelector(".product-form__submit") ||
            document.querySelector(".product-form__submit");
        if (addToCartButton) {
          addToCartButton.classList.remove("no-size-selected-yet");
          addToCartButton.disabled = false;
          addToCartButton.removeAttribute("disabled");
          const addToCartButtonText = addToCartButton.querySelector(".button-text") || addToCartButton.querySelector("span");
          if (addToCartButtonText && window.variantStrings) {
            addToCartButtonText.textContent = window.variantStrings.addToCart;
          }
        }

        // ALWAYS update the UI to ensure the dropdown header reflects the forced state
        const dropdown_headers = this.querySelectorAll(".custom-select-dropdown-header");
        const valueName = option.getAttribute("data-value-handle");
        const valueSize = option.getAttribute("data-value-size");
        const valueSizePrint = option.getAttribute("data-value-size-print");

        if (valueName) {
          dropdown_headers.forEach((header) => {
            const selectHeaderText = header.querySelector(".select-header-text");
            if (selectHeaderText) {
              selectHeaderText.innerHTML = `${valueName}<span class="option-dimensions"><span class="frame-size">${valueSize || ""}</span><span class="print-size">${valueSizePrint || ""}</span></span>`;
            }
          });
        }

        this.toggleSizeSelectorActive(true);
      }
    };

    const showOnlyMiniSize = isMiniFrameStyle(selectedOption);
    const hideMiniSize = !showOnlyMiniSize; // any other frame style

    const printSizeDropdownWrap = this.querySelector("#product-select-print-size");
    const dropdownHeaders = this.querySelectorAll(".custom-select-dropdown-header");
    if (printSizeDropdownWrap) {
      if (showOnlyMiniSize) {
        printSizeDropdownWrap.style.pointerEvents = "none";
        printSizeDropdownWrap.style.opacity = "0.5";
        dropdownHeaders.forEach((header) => {
          header.style.pointerEvents = "none";
          header.style.opacity = "0.5";
        });
      } else {
        printSizeDropdownWrap.style.pointerEvents = "";
        printSizeDropdownWrap.style.opacity = "";
        dropdownHeaders.forEach((header) => {
          header.style.pointerEvents = "";
          header.style.opacity = "";
        });
      }
    }

    sizeOptions.forEach((option) => {
      const handle = option.dataset.valueHandle;
      if (showOnlyMiniSize) {
        option.style.display = isMiniSizeHandle(handle) ? "flex" : "none";
        return;
      }

      if (hideMiniSize && isMiniSizeHandle(handle)) {
        option.style.display = "none";
        return;
      }

      option.style.display = "flex";
    });

    if (showOnlyMiniSize) {
      selectSizeByHandle("Mini");
      return;
    }

    // Determine currently checked size
    let currentCheckedSize = null;
    sizeOptions.forEach((opt) => {
      const inp = opt.querySelector('input[type="radio"]');
      if (inp && inp.checked) currentCheckedSize = opt.dataset.valueHandle;
    });

    // If current checked size is Mini but it's not allowed for this frame style, move to Small.
    if (isMiniSizeHandle(currentCheckedSize) && hideMiniSize) {
      const smallOption = Array.from(sizeOptions).find((opt) => opt.dataset.valueHandle === "Small");
      const smallInput = smallOption?.querySelector('input[type="radio"]');

      if (smallInput) {
        smallOption.classList.remove("disabled");
        smallInput.classList.remove("disabled");
        smallInput.removeAttribute("disabled");

        smallOption.click();
        smallInput.checked = true;
        smallInput.dispatchEvent(new Event("change", {bubbles: true}));

        // ALWAYS update the UI to ensure the dropdown header reflects the fallback state
        const dropdown_headers = this.querySelectorAll(".custom-select-dropdown-header");
        const valueName = smallOption.getAttribute("data-value-handle");
        const valueSize = smallOption.getAttribute("data-value-size");
        const valueSizePrint = smallOption.getAttribute("data-value-size-print");

        if (valueName) {
          dropdown_headers.forEach((header) => {
            const selectHeaderText = header.querySelector(".select-header-text");
            if (selectHeaderText) {
              selectHeaderText.innerHTML = `${valueName}<span class="option-dimensions"><span class="frame-size">${valueSize || ""}</span><span class="print-size">${valueSizePrint || ""}</span></span>`;
            }
          });
        }

        this.toggleSizeSelectorActive(true);
        // do not return, continue to enable the rest of the sizes below
      }
    }
  }

  handleLeadTimes(variant) {
    const activeVariant = variant || this.currentVariant;
    const sectionId = this.dataset?.section;
    const productForm = sectionId && document.getElementById(`product-form-${sectionId}`);
    const quickshopDrawer = this.closest(".quickshop-drawer") || document.querySelector(".quickshop-drawer.active") || null;
    const upsellContainer = this.closest(".drawer__upsell-main-content");

    const resolveString = (value) => (typeof value === "string" ? value.trim() : "");
    const parseIndex = (value) => {
      if (value === undefined || value === null || value === "") return null;
      const parsed = Number(value);
      return Number.isNaN(parsed) ? null : parsed;
    };

    const typeSource =
      resolveString(this.dataset?.productType) ||
      resolveString(productForm?.dataset?.productType) ||
      resolveString(upsellContainer?.dataset?.productType) ||
      resolveString(quickshopDrawer?.dataset?.productType) ||
      resolveString(window.productJSON?.type);
    const type = typeSource;

    let optionIndex = -1;
    const indexSources = [
      parseIndex(this.dataset?.printSizeIndex),
      parseIndex(productForm?.dataset?.printSizeIndex),
      parseIndex(upsellContainer?.dataset?.printSizeIndex),
      parseIndex(quickshopDrawer?.dataset?.printSizeIndex),
    ];

    for (const idx of indexSources) {
      if (idx !== null && idx > -1) {
        optionIndex = idx;
        break;
      }
    }

    if (optionIndex === -1 && Array.isArray(window.productJSON?.options)) {
      optionIndex = window.productJSON.options.findIndex((o) => String(o || "").toLowerCase() === "print size");
    }

    if (quickshopDrawer) {
      if (type) quickshopDrawer.dataset.productType = type;
      if (optionIndex > -1) {
        quickshopDrawer.dataset.printSizeIndex = String(optionIndex);
      }
    }

    if (productForm) {
      if (type) productForm.dataset.productType = type;
      if (optionIndex > -1) {
        productForm.dataset.printSizeIndex = String(optionIndex);
      }
    }

    const selectedSize = optionIndex > -1 ? activeVariant?.options?.[optionIndex] : null;
    const leadTimesSettings = window.themeSettings?.productLeadTimes || "";

    let message = null;

    if (leadTimesSettings && type && selectedSize) {
      // Parse the line-separated list from theme settings
      const leadTimeEntries = leadTimesSettings.split("\n").filter((line) => line.trim());

      // Look for matching [type][selectedSize]:message format
      const targetKey = `[${type}][${selectedSize}]`.toLowerCase();

      for (const entry of leadTimeEntries) {
        const trimmedEntry = entry.trim();

        // Check if entry matches the pattern [type][selectedSize]:message
        if (trimmedEntry.toLowerCase().startsWith(targetKey + ":")) {
          // Extract the message part after the colon
          const colonIndex = trimmedEntry.indexOf(":");
          if (colonIndex !== -1 && colonIndex < trimmedEntry.length - 1) {
            message = trimmedEntry.substring(colonIndex + 1).trim();
            break;
          }
        }
      }
    }
    const messageClassName = "product-form__lead-time-message";
    const existingMessage = productForm?.querySelector(`.${messageClassName}`);
    const isCartDrawerSection = sectionId === "cart-drawer";
    const isQuickshopActive = !!quickshopDrawer && quickshopDrawer.classList.contains("active");

    if (isCartDrawerSection) {
      const submitButton = productForm?.querySelector(".ProductSubmitButton-cart-drawer, #ProductSubmitButton-cart-drawer");
      if (message && productForm && submitButton && isQuickshopActive) {
        let messageElement = existingMessage;
        if (!messageElement) {
          messageElement = document.createElement("div");
          messageElement.className = messageClassName;
          messageElement.setAttribute("role", "status");
          messageElement.setAttribute("aria-live", "polite");
        }
        messageElement.textContent = `Ships within ${message}`;
        submitButton.before(messageElement);
      } else if (existingMessage) {
        existingMessage.remove();
      }
    } else if (productForm) {
      const buttonsWrapper = productForm.querySelector(".product-form__buttons") || null;
      if (message && buttonsWrapper) {
        let messageElement = existingMessage;
        if (!messageElement) {
          messageElement = document.createElement("div");
          messageElement.className = messageClassName;
          messageElement.setAttribute("role", "status");
          messageElement.setAttribute("aria-live", "polite");
          buttonsWrapper.before(messageElement);
        }
        messageElement.textContent = `Ships within ${message}`;
      } else if (existingMessage) {
        existingMessage.remove();
      }
    }

    const leadTimeInputClass = "product-form__lead-time-input";
    let leadTimeInput = productForm?.querySelector(`input.${leadTimeInputClass}`);
    const shouldAttachLeadTime = !!message && productForm && (!isCartDrawerSection || isQuickshopActive);

    if (shouldAttachLeadTime) {
      if (!leadTimeInput) {
        leadTimeInput = document.createElement("input");
        leadTimeInput.type = "hidden";
        leadTimeInput.className = leadTimeInputClass;
        productForm.appendChild(leadTimeInput);
      }
      leadTimeInput.name = "properties[Ships within]";
      leadTimeInput.value = message;
    } else if (leadTimeInput) {
      leadTimeInput.value = "";
      leadTimeInput.removeAttribute("name");
    }
  }

  // Sticky scroll button logic to get the product options in view
  initStickyScrollButton() {
    // Only initialize on small screens
    if (window.innerWidth >= 769) return;

    let lastScrollY = window.scrollY;
    let isScrollingDown = false;
    let stickyButton = null;
    let scrollDelta = 0;
    let isButtonVisible = false;
    let stableDirectionTimeout = null;

    // Require minimum scroll distance to change direction
    const SCROLL_THRESHOLD = 8;
    const DIRECTION_DEBOUNCE = 100; // ms to wait before direction change takes effect

    const createStickyButton = () => {
      if (stickyButton) return stickyButton;

      // Create button container
      const container = document.createElement("div");
      container.className = "product__sticky-options–-wrap";

      // Create button (styled like related-product-bundle-button a)
      const button = document.createElement("button");
      button.className = "product__sticky-options–-button";
      button.textContent = "Back to Options";

      // Add click handler to scroll to variant picker
      button.addEventListener("click", () => {
        const variantPicker = document.querySelector(".variant-picker__container");
        if (variantPicker) {
          const header = document.querySelector("header") || document.querySelector(".header");
          const headerHeight = header ? header.offsetHeight : 60;
          const targetPosition = variantPicker.offsetTop - headerHeight - 100;

          window.scrollTo({
            top: targetPosition,
            behavior: "smooth",
          });
        }
      });

      container.appendChild(button);
      document.body.appendChild(container);
      stickyButton = container;

      return container;
    };

    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const variantPicker = document.querySelector(".variant-picker__container");

      if (!variantPicker) return;

      // Calculate scroll delta
      const currentDelta = currentScrollY - lastScrollY;

      // Only update direction if we've scrolled a meaningful amount
      if (Math.abs(currentDelta) > SCROLL_THRESHOLD) {
        const newDirection = currentDelta > 0;

        // If direction changed, debounce it
        if (newDirection !== isScrollingDown) {
          if (stableDirectionTimeout) {
            clearTimeout(stableDirectionTimeout);
          }

          stableDirectionTimeout = setTimeout(() => {
            isScrollingDown = newDirection;
            lastScrollY = currentScrollY;
            updateButtonVisibility();
          }, DIRECTION_DEBOUNCE);
        } else {
          // Same direction, update immediately
          lastScrollY = currentScrollY;
          updateButtonVisibility();
        }
      }

      function updateButtonVisibility() {
        // Check if variant picker is out of view
        const variantPickerRect = variantPicker.getBoundingClientRect();
        const isOutOfView = variantPickerRect.bottom < 0;

        // Check if footer is in view
        const footer = document.querySelector(".footer");
        const isFooterInView = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;

        // Show button if scrolling down, variant picker is out of view, and footer is not in view
        const shouldShow = isScrollingDown && isOutOfView && !isFooterInView;

        if (shouldShow && !isButtonVisible) {
          const button = createStickyButton();
          button.style.transform = "translateY(0)";
          isButtonVisible = true;
        } else if (!shouldShow && isButtonVisible && stickyButton) {
          // Hide button if scrolling up, variant picker is in view, or footer is visible
          stickyButton.style.transform = "translateY(100%)";
          isButtonVisible = false;
        }
      }
    };

    // Add scroll listener with throttling
    let scrollTimeout;
    window.addEventListener("scroll", () => {
      if (scrollTimeout) clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(handleScroll, 33); // ~30fps for smoother momentum handling
    });

    // Handle window resize
    window.addEventListener("resize", () => {
      if (window.innerWidth >= 769 && stickyButton) {
        // Clean up timeouts
        if (stableDirectionTimeout) {
          clearTimeout(stableDirectionTimeout);
          stableDirectionTimeout = null;
        }
        if (scrollTimeout) {
          clearTimeout(scrollTimeout);
          scrollTimeout = null;
        }

        stickyButton.remove();
        stickyButton = null;
        isButtonVisible = false;
      }
    });
  }

  clickOnSizeOption(dropdown, dropdown_header, variantChange) {
    const bodyOverlay = document.getElementById("body-overlay");
    const sizeOptions = this.querySelectorAll(".input-label-wrap.option-input");
    const selector_footer = this.querySelector(".selection-footer .edition-note");
    const selector_footer_drawer = this.querySelector(".upsell-variant-options .selection-footer .edition-note");
    const editionPrintWrap = this.querySelector(".selection-footer .edition-print");
    const editionPrintWrapDrawer = this.querySelector(".upsell-variant-options .selection-footer .edition-print");

    sizeOptions.forEach((option) => {
      option.addEventListener("click", function (event) {
        console.log(
          "CLICK ON SIZE OPTION:",
          this.getAttribute("data-value-handle"),
          " Is disabled?",
          this.classList.contains("disabled"),
        );
        if (this.classList.contains("disabled")) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }

        const valueType = this.getAttribute("data-value-type");
        const valueName = this.getAttribute("data-value-handle");
        const valueSize = this.getAttribute("data-value-size");
        const valueSizePrint = this.getAttribute("data-value-size-print");
        const editionCount = this.getAttribute("data-value-edition-count");
        const editionType = this.getAttribute("data-value-edition-type");
        const formId = this.getAttribute("data-add-to-cart-form");
        const addToCartButton = document.getElementById(formId);
        const currentSection = this.dataset.section;
        const addToCartButtonText = addToCartButton.querySelector(".button-text");

        // if(currentSection == 'cart-drawer'){
        //   selector_footer_drawer.innerHTML = '';
        //   editionPrintWrapDrawer.style.display = 'none';
        // } else {
        //   selector_footer.innerHTML = '';
        //   editionPrintWrap.style.display = 'none';
        // }

        if (valueType == "print-size") {
          dropdown_header.forEach((header) => {
            header.querySelector(".select-header-text").innerHTML =
              `${valueName}` +
              `<span class="option-dimensions"><span class="frame-size">${valueSize}</span><span class="print-size">${valueSizePrint}</span></span>`;
          });
          dropdown.classList.remove("active");
          bodyOverlay?.classList.remove("show");
          // A Size has been selected. Allow add to cart now.
          addToCartButton.classList.remove("no-size-selected-yet");
          addToCartButton.removeAttribute("disabled");
          addToCartButtonText.textContent = window.variantStrings.addToCart;
          if (editionCount && editionType && editionType == "First") {
            selector_footer.innerHTML = editionType + " Edition Print";
            if (currentSection == "cart-drawer") {
              editionPrintWrapDrawer.style.display = "flex";
            } else {
              editionPrintWrap.style.display = "flex";
            }
          }
        } else if (valueType == "phone-size") {
          dropdown_header.forEach((header) => {
            header.querySelector(".select-header-text").innerHTML = `${valueSize}`;
          });
          dropdown.classList.remove("active");
          bodyOverlay?.classList.remove("show");
          // A Case has been selected. Allow add to cart now.
          addToCartButton.classList.remove("no-size-selected-yet");
          addToCartButton.removeAttribute("disabled");
          addToCartButtonText.textContent = window.variantStrings.addToCart;
        }
      });
    });
  }

  onVariantChange() {
    const currentSection = this.dataset.section;
    const antiGlareInput = this.querySelector(".option-glare input");
    const antiGlareTitle = this.querySelector(".anti-glare-title");
    const antiGlareDescription = this.querySelector(".anti-glare-description");
    const noFrameInput = this.querySelector(".noframe-input");
    const sizeOptions = this.querySelectorAll("#product-select-print-size .input-label-wrap.option-input");
    const frameOptions = this.querySelectorAll(".input-label-wrap.frame-style");
    const colorOptions = this.querySelectorAll(".color-swatch");
    const editionPrint = this.querySelector(".selection-footer .edition-note");
    const editionPrintDrawer = this.querySelector(".upsell-variant-options .selection-footer .edition-note");
    const editionPrintWrap = this.querySelector(".selection-footer .edition-print");
    const editionPrintWrapDrawer = this.querySelector(".upsell-variant-options .selection-footer .edition-print");
    const onlyPA = this.querySelector(".only-pa");
    const whiteFrameOption = this.querySelector('.color-swatch label[data-value="White"].white-frame');
    const paperSizeLabel = this.querySelectorAll(".paper");
    const optionDimensions = this.querySelectorAll(".option-dimensions");

    this.setSelectedOptions();
    this.setSelectedVariant();

    const collectorRow = Array.from(sizeOptions).find((o) => o.dataset.valueHandle === "Collector");

    const isSelectedCollector = isCollectorSizeSelected(this, sizeOptions);
    const hideGlareForCollectorNoFrame = shouldHideGlareForCollectorNoFrame(
      this,
      sizeOptions,
      this.currentVariant,
    );
    const showCollectorPremiumAcrylic = shouldShowCollectorPremiumAcrylic(this, sizeOptions, this.currentVariant);

    var isHiddenCollector = false;

    updateGlareUiForCollector(this, showCollectorPremiumAcrylic, hideGlareForCollectorNoFrame);

    // Update Anti-Glare helper copy based on selected frame style
    if (
      !showCollectorPremiumAcrylic &&
      !hideGlareForCollectorNoFrame &&
      this.currentVariant &&
      antiGlareTitle &&
      antiGlareDescription
    ) {
      const isShadowBox =
        this.currentVariant.option1 === "Shadow Box" ||
        this.currentVariant.option1 === "No Frame" ||
        this.currentVariant.option1 === "Mini" ||
        (this.currentVariant.title && this.currentVariant.title.indexOf("Shadow Box") > -1);

      if (isShadowBox) {
        antiGlareTitle.textContent = "Anti-glare";
        antiGlareDescription.textContent = "Available only on Premium Archival";
      } else {
        antiGlareTitle.textContent = "Add Anti-Glare";
        antiGlareDescription.textContent = "Ideal for bright rooms";
      }
    }

    // TODO: clean this up
    // Keep the Anti-Glare checkbox in sync with the selected variant
    if (!showCollectorPremiumAcrylic && !hideGlareForCollectorNoFrame && antiGlareInput && this.currentVariant) {
      const isAntiGlare =
        (this.currentVariant.option1 && this.currentVariant.option1.indexOf("Anti-Glare") > -1) ||
        (this.currentVariant.option2 && this.currentVariant.option2.indexOf("Anti-Glare") > -1) ||
        (this.currentVariant.option3 && this.currentVariant.option3.indexOf("Anti-Glare") > -1);

      antiGlareInput.checked = isAntiGlare;
      antiGlareInput.toggleAttribute("checked", isAntiGlare);
    }

    this.toggleAddButton(true, "", false);
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.updateSelectedOptionValue();

    const currentVariantName = this.currentVariant ? this.currentVariant.option1 : this.options ? this.options[0] : null;

    if (currentVariantName) {
      // this.setSelectedOptions();
      this.setSelectedVariant();

      // Auto-select White color if Mini Frame is selected and the current color is not White or Black
      // TODO: maybe move this?
      // if (isMiniFrameStyle(currentVariantName)) {
      //   let currentColor = null;
      //   colorOptions.forEach((option) => {
      //     var input = option.querySelector("input");
      //     if (input && input.checked) currentColor = input.value;
      //   });

      //   if (currentColor !== "White" && currentColor !== "Black") {
      //     // Find first allowed color option that actually exists
      //     const validOption =
      //       Array.from(colorOptions).find((opt) => {
      //         const inp = opt.querySelector("input");
      //         return inp && (inp.value === "White" || inp.value === "Black") && !inp.classList.contains("disabled");
      //       }) ||
      //       Array.from(colorOptions).find((opt) => {
      //         const inp = opt.querySelector("input");
      //         return inp && (inp.value === "White" || inp.value === "Black");
      //       });

      //     if (validOption) {
      //       const validInput = validOption.querySelector("input");
      //       if (validInput) {
      //         validInput.checked = true;
      //         validInput.dispatchEvent(new Event("change", {bubbles: true}));
      //         validOption.click();
      //       }
      //     }
      //   }
      // }

      // Begin: The following code is responsible for setting the scroll position of Frames & Sizes panel to the image that correlates to the size user currently has selected.
      // TODO: does this even work?
      const currentSizeSelected = "size-" + currentVariantName;
      const targetElement = document.getElementById(currentSizeSelected);
      if (targetElement && window.innerWidth < 769) {
        targetElement.scrollIntoView({behavior: "smooth", block: "start"});
      }
    }

    if (!this.currentVariant) {
      console.log("CRITICAL: Variant matching failed using these exact options:", JSON.stringify(this.options));
      console.log(
        "Available variants dump:",
        this.getVariantData()
          .map((v) => v.options.join(" | "))
          .slice(0, 10),
      ); // print first 10
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
      if (antiGlareInput) antiGlareInput.setAttribute("disabled", "true");
    } else {
      this.updateMedia();
      this.updateVariantInput();
      this.renderProductInfo();
      if (this.dataset.section !== "cart-drawer") {
        this.updateURL();
        this.updateShareUrl();
      }
      this.updateColorSwatchSelectionAbility();
      this.handleLeadTimes(this.currentVariant);
    }

    // show lead times based on variant selection
    this.handleLeadTimes();
    this.updateLineItemProperties();
    this.updateVariantDisplayProperty();

    const {wasNoFrame, previousValue} = trackPreviousOption1(this.currentVariant);

    let selectedEditionType = null;

    sizeOptions.forEach((option) => {
      const radio = option.querySelector('input[type="radio"]');
      if (radio && radio.checked) {
        selectedEditionType = option;
      }
    });

    // TODO: Refactor timeout
    if (selectedEditionType) {
      setTimeout(function () {
        const editionTypeText = selectedEditionType.querySelector(".edition-type-note")?.innerHTML;
        if (editionTypeText) {
          if (currentSection == "cart-drawer") {
            editionPrintWrapDrawer.style.display = "none";
            editionPrintDrawer.innerHTML = editionTypeText;
            editionPrintWrapDrawer.style.display = "flex";
          } else {
            editionPrintWrap.style.display = "none";
            editionPrint.innerHTML = editionTypeText;
            editionPrintWrap.style.display = "flex";
          }
        }
      }, 1000);
    }

    this.onUpdateGallery();

    const setNoFrameAvailability = (shouldDisable) => {
      if (!noFrameInput) return;
      const targetInput = noFrameInput.matches("input") ? noFrameInput : noFrameInput.querySelector("input");

      noFrameInput.classList.toggle("disabled", shouldDisable);
      if (targetInput) {
        targetInput.toggleAttribute("disabled", shouldDisable);
        targetInput.disabled = shouldDisable;
      }
    };

    var frameStyle = this.currentVariant?.option1;
    const noFrameWrap = noFrameInput?.closest?.(".input-label-wrap");
    const disableNoFrameForMini = !!frameStyle && isMiniFrameStyle(frameStyle);
    setNoFrameAvailability(disableNoFrameForMini);
    if (noFrameWrap) {
      noFrameWrap.style.display = "";
    }

    // Keep mini print size visible only for mini frame style.
    // For all non-mini frame styles (including No Frame), hide mini and move selection to Small if needed.
    const isMiniFrameSelected = !!frameStyle && isMiniFrameStyle(frameStyle);
    let hadCheckedMiniSize = false;
    sizeOptions.forEach((option) => {
      const input = option.querySelector("input");
      const isMiniSize = isMiniSizeHandle(option.dataset.valueHandle);

      if (isMiniFrameSelected) {
        option.style.display = isMiniSize ? "flex" : "none";
        if (isMiniSize && input) {
          input.classList.remove("disabled");
          input.parentElement?.classList.remove("disabled");
        }
        return;
      }

      if (isMiniSize) {
        option.style.display = "none";
        if (input?.checked) hadCheckedMiniSize = true;
        if (input) {
          input.checked = false;
          input.classList.add("disabled");
          input.parentElement?.classList.add("disabled");
        }
      }
    });

    if (!isMiniFrameSelected && hadCheckedMiniSize) {
      const smallOption = Array.from(sizeOptions).find(
        (option) => String(option.dataset.valueHandle || "").trim().toLowerCase() === "small",
      );
      smallOption?.querySelector("input")?.click();
    }

    this.currentVariant && this.setSizeAndColorOptions(antiGlareInput, colorOptions, sizeOptions, onlyPA, previousValue);

    // End: Manage the Edition Type in the size select dropdown
    //If Shadow Box Frame is selected disable Anti Glare
    if (this.currentVariant && this.currentVariant.title.includes("Shadow Box")) {
      if (!antiGlareInput.checked) {
        antiGlareInput.setAttribute("disabled", "true");
        //this.toggleAddButton(true, '', true);
      }
      if (this.currentVariant.option2.includes("Blue") || this.currentVariant.option2.includes("Natural")) {
        onlyPA.classList.add("show");
      } else {
        onlyPA.classList.remove("show");
      }
      
      sizeOptions.forEach((option) => {
        var input = option.querySelector("input");
        if (option.dataset.valueHandle == "Collector") {
          option.style.display = "none";
          if (input && input.checked) {
            input.checked = false;
            input.classList.add("disabled");
          }
          input.parentElement.classList.add("disabled");

          isHiddenCollector = true;
        } else if (isMiniSizeHandle(option.dataset.valueHandle)) {
          option.style.display = "none";
          if (input && input.checked) {
            input.checked = false;
            input.classList.add("disabled");
          }
          input.parentElement.classList.add("disabled");
        } else if (option.dataset.valueHandle == "Small") {
          option.style.display = "";
          if (input) {
            input.classList.remove("disabled");
            input.parentElement.classList.remove("disabled");
          }
        } else {
          option.style.display = "";
          if (this.currentVariant.available && input) {
            input.classList.remove("disabled");
            input.parentElement.classList.remove("disabled");
          }
        }
      });
    } else if (this.currentVariant && this.currentVariant.title.includes("Premium Archival")) {
      colorOptions.forEach((option) => {
        var input = option.querySelector("input");
        option.classList.remove("disabled");
        input.classList.remove("disabled");
      });
      sizeOptions.forEach((option) => {
        var input = option.querySelector("input");
        if (isMiniSizeHandle(option.dataset.valueHandle)) {
          option.style.display = "none";
          if (input && input.checked) {
            input.checked = false;
            input.classList.add("disabled");
          }
          input.parentElement.classList.add("disabled");
        } else if (option.dataset.valueHandle == "Small") {
          option.style.display = "";
          if (input) {
            input.classList.remove("disabled");
            input.parentElement.classList.remove("disabled");
          }
        } else {
          option.style.display = "";
          if (this.currentVariant.available && input) {
            input.classList.remove("disabled");
            input.parentElement.classList.remove("disabled");
          }
        }
      });

      //antiGlareInput.removeAttribute('disabled');
      if (onlyPA) onlyPA.classList.remove("show");
    } else if (this.currentVariant) {
      sizeOptions.forEach((option) => {
        if (option.dataset.valueHandle !== "Collector") return;
        const miniFrame = isMiniFrameStyle(this.currentVariant.option1);
        option.style.display = miniFrame ? "none" : "";
        const input = option.querySelector("input");
        if (!miniFrame && input && this.currentVariant.available) {
          input.classList.remove("disabled");
          input.parentElement.classList.remove("disabled");
        }
        
        isHiddenCollector = false;
      });
    }

    // Reset on each variant change. It will update below if applicable
    paperSizeLabel.forEach((label) => {
      label.style.display = "none";
    });
    optionDimensions.forEach((label) => {
      label.classList.remove("show-print-size");
    });

    if (this.currentVariant && this.currentVariant.option1 === "Shadow Box") {
      const rawColor = this.currentVariant.option2
        .toLowerCase()
        .replace(/anti-glare/gi, "")
        .trim();
      const handleizedColor = rawColor.replace(/\s+/g, "-");

      // COLOR OPTIONS — Add 'shadow-box-' after '/assets/' and remove '-anti-glare'
      colorOptions.forEach((swatch) => {
        const swatch_input = swatch.querySelector("input");
        const swatch_value = swatch_input?.value?.trim();

        // Skip dynamic updates for the 'No Frame' swatch
        if (swatch_value?.toLowerCase() === "no frame") return;

        let url = swatch_input.getAttribute("data-url");
        let url_ns = swatch_input.getAttribute("data-url-ns");

        // Always remove '-anti-glare'
        url = url.replace(/-anti-glare/gi, "");
        url_ns = url_ns.replace(/-anti-glare/gi, "");

        // Insert 'shadow-box-' after '/assets/' if not already present
        url = url.replace(/(\/assets\/)(?!shadow-box-)/, "$1shadow-box-");
        url_ns = url_ns.replace(/(\/assets\/)(?!shadow-box-)/, "$1shadow-box-");

        swatch_input.setAttribute("data-url", url);
        swatch_input.setAttribute("data-url-ns", url_ns);
      });

      // FRAME OPTIONS — Replace color and remove '-anti-glare'; DO NOT insert 'shadow-box-'
      frameOptions.forEach((frame) => {
        const frame_input = frame.querySelector("input");

        let url = frame_input.getAttribute("data-url");
        let url_ns = frame_input.getAttribute("data-url-ns");

        // Skip dynamic updates if the current color is no-frame
        if (handleizedColor?.toLowerCase() === "no-frame") return;

        // Always remove '-anti-glare' first
        url = url.replace(/-anti-glare/gi, "");
        url_ns = url_ns.replace(/-anti-glare/gi, "");

        // Normalize any existing color after 'shadow-box-' or anywhere in string
        url = url.replace(/(shadow-box-)([^-/]+)/i, `$1${handleizedColor}`);
        url = url.replace(/\b(white|black|blue|natural|no-frame)\b/gi, handleizedColor);
        url = url.replace("-frame", "");

        url_ns = url_ns.replace(/(shadow-box-)([^-/]+)/i, `$1${handleizedColor}`);
        url_ns = url_ns.replace(/\b(white|black|blue|natural|no-frame)\b/gi, handleizedColor);
        url_ns = url_ns.replace("-frame", "");

        frame_input.setAttribute("data-url", url);
        frame_input.setAttribute("data-url-ns", url_ns);
      });
    } else if (this.currentVariant && this.currentVariant.option1 === "Premium Archival") {
      const rawColor = this.currentVariant.option2
        .toLowerCase()
        .replace(/anti-glare/gi, "")
        .trim();
      const handleizedColor = rawColor.replace(/\s+/g, "-");

      const colorRegex = /\b(white|black|blue|natural|no-frame)\b/gi;

      // COLOR OPTIONS — Remove 'shadow-box-' and '-anti-glare'
      colorOptions.forEach((swatch) => {
        const swatch_input = swatch.querySelector("input");
        const swatch_value = swatch_input?.value?.trim();

        // Skip dynamic updates for the 'No Frame' swatch
        if (swatch_value?.toLowerCase() === "no frame") return;

        let url = swatch_input.getAttribute("data-url");
        let url_ns = swatch_input.getAttribute("data-url-ns");

        url = url.replace(/shadow-box-/gi, "");
        url_ns = url_ns.replace(/shadow-box-/gi, "");

        url = url.replace(/-anti-glare/gi, "");
        url_ns = url_ns.replace(/-anti-glare/gi, "");

        swatch_input.setAttribute("data-url", url);
        swatch_input.setAttribute("data-url-ns", url_ns);
      });

      // FRAME OPTIONS — Remove '-anti-glare' then replace color
      frameOptions.forEach((frame) => {
        const frame_input = frame.querySelector("input");

        let url = frame_input.getAttribute("data-url");
        let url_ns = frame_input.getAttribute("data-url-ns");

        // Remove '-anti-glare' first
        url = url.replace(/-anti-glare/gi, "");
        url_ns = url_ns.replace(/-anti-glare/gi, "");

        // Replace color
        url = url.replace(colorRegex, handleizedColor);
        url_ns = url_ns.replace(colorRegex, handleizedColor);

        frame_input.setAttribute("data-url", url);
        frame_input.setAttribute("data-url-ns", url_ns);
      });
    } else if (this.currentVariant && this.currentVariant.option1 == "No Frame") {
      const noFrameColor = this.querySelector(".no-frame-frame");
      noFrameColor.click();
      paperSizeLabel.forEach((label) => {
        label.style.display = "inline";
      });
      optionDimensions.forEach((label) => {
        label.classList.add("show-print-size");
      });
    }

    if (wasNoFrame && this.currentVariant?.option1 !== "No Frame") {
      whiteFrameOption.click();
    }

    
    if (isSelectedCollector && isHiddenCollector) {
      sizeOptions.forEach((option) => {
        if (option.dataset.valueHandle === "Oversized") {
          option.querySelector("input").click();
        }
      });
    }

    window.oldFrameStyle = frameStyle;
  }

  setSizeAndColorOptions(antiGlareInput, colorOptions, sizeOptions, onlyPA, previousValue) {
    // If Mini is chosen as Frame Style (option1)
    const isMiniFrame = isMiniFrameStyle(this.currentVariant.option1);
    const wasMiniFrameContext = isMiniFrameStyle(previousValue);

    if (isMiniFrame) {
      const option = Array.from(sizeOptions).find((opt) => isMiniSizeHandle(opt.dataset.valueHandle));

      if (option) option.querySelector("input").click();
    } else if (wasMiniFrameContext) {
      const option = Array.from(sizeOptions).find(
        (opt) => String(opt.dataset.valueHandle || "").trim().toLowerCase() === "small",
      );
      if (option) option.click();
    }

    if (isMiniFrame) {
      // hide anti-glare option
      if (antiGlareInput && !antiGlareInput.checked) {
        antiGlareInput.setAttribute("disabled", "true");
      }
    }

    // // If Mini is chosen as Frame Style (option1)
    // if (isMiniFrameStyle(this.currentVariant.option1)) {
    //   // set mini print size as the default
    //   const option = this.querySelector(
    //     `#product-select-print-size .input-label-wrap.option-input[data-value-handle="Mini"]`,
    //   );
    //   option.click();

    //   // hide anti-glare option
    //   if (antiGlareInput && !antiGlareInput.checked) {
    //     antiGlareInput.setAttribute("disabled", "true");
    //   }

    //   // // disable all colors but white and black (only options available for minis)
    //   // colorOptions.forEach((option) => {
    //   //   var input = option.querySelector("input");
    //   //   if (input) {
    //   //     if (input.value !== "White" && input.value !== "Black") {
    //   //       input.classList.add("disabled");
    //   //       input.setAttribute("disabled", "disabled"); // Make sure it's fully disabled
    //   //     }
    //   //   }
    //   // });
    // } else {
    //   // set small print size as the default
    //   const option = this.querySelector(
    //     `#product-select-print-size .input-label-wrap.option-input[data-value-handle="Small"]`,
    //   );
    //   option.click();

    //   // // Re-enable color options when leaving Mini Frame Style so users can pick Natural again
    //   // colorOptions.forEach((option) => {
    //   //   var input = option.querySelector("input");
    //   //   if (input) {
    //   //     input.classList.remove("disabled");
    //   //     input.removeAttribute("disabled");
    //   //   }
    //   // });

    //   // sizeOptions.forEach((option) => {
    //   //   var input = option.querySelector("input");
    //   //   if (option.dataset.valueHandle != "Mini") {
    //   //     if (input && !input.checked) {
    //   //       if (input.checked) input.checked = false;
    //   //       input.classList.add("disabled");
    //   //     }
    //   //     input.parentElement.classList.add("disabled");
    //   //   } else {
    //   //     if (input && !input.checked) {
    //   //       input.checked = true;
    //   //       input.classList.remove("disabled");
    //   //       input.parentElement.classList.remove("disabled");

    //   //       const dropdown_header = this.querySelectorAll(".custom-select-dropdown-header");
    //   //       const valueName = option.getAttribute("data-value-handle");
    //   //       const valueSize = option.getAttribute("data-value-size");
    //   //       const valueSizePrint = option.getAttribute("data-value-size-print");

    //   //       dropdown_header.forEach((header) => {
    //   //         const selectHeaderText = header.querySelector(".select-header-text");
    //   //         if (selectHeaderText && valueName) {
    //   //           selectHeaderText.innerHTML = `${valueName}<span class="option-dimensions"><span class="frame-size">${valueSize || ""}</span><span class="print-size">${valueSizePrint || ""}</span></span>`;
    //   //         }
    //   //       });

    //   //       input.dispatchEvent(new Event("change", {bubbles: true}));

    //   //       option.click();
    //   //     }
    //   //   }
    //   // });

    //   if (onlyPA) onlyPA.classList.remove("show");
    // }
  }

  onUpdateGallery() {
    var frameStyle = this.currentVariant?.option1;
    var mainSelector = ".product__media-wrapper .main-product-gallery";
    var thumbSelector = ".product__media-wrapper .main-thubnails";
    var thumbVisibleCount = 7;
    var isMobileGallery = window.matchMedia("(max-width: 767px)").matches;

    var main_slider = $(mainSelector);
    var thumbnail_slider = $(thumbSelector);

    if (!main_slider.length) return;

    // --- Helper predicates (aligned with custom.js PDP slickFilter rules)

    function isMiniMarked(el) {
      return el.classList.contains("mini-composite") || !!el.querySelector(".mini-composite");
    }
    function isSlideMainEl(el) {
      return el.classList.contains("slide-main") || !!el.querySelector(".slide-main");
    }

    // In "Mini" mode, KEEP slides that are mini-marked OR slide-main
    function keepMini(el) {
      return isMiniMarked(el) || isSlideMainEl(el);
    }

    // In non-Mini mode, KEEP slides that are NOT mini-marked OR slide-main (slide-main is never filtered out)
    function keepNonMini(el) {
      return !isMiniMarked(el) || isSlideMainEl(el);
    }

    // --- Only proceed if the variant actually changed
    if (window.oldFrameStyle != frameStyle) {
      // Rebuild both carousels when Mini/non-Mini changes so add/remove slide behavior
      // stays stable (Slick filter alone can leave stale clone/index state).
      try {
        if (main_slider.hasClass("slick-initialized")) main_slider.slick("unslick");
      } catch (e) {
        /* noop */
      }
      try {
        if (thumbnail_slider.hasClass("slick-initialized")) thumbnail_slider.slick("unslick");
      } catch (e) {
        /* noop */
      }

      main_slider = $(mainSelector);
      thumbnail_slider = $(thumbSelector);

      var canUseThumbs = thumbnail_slider.length && !isMobileGallery;
      var shouldLoopBase = canUseThumbs && thumbnail_slider.children().length > thumbVisibleCount;

      var mainGalleryOpts = {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: false,
        dots: true,
        infinite: shouldLoopBase,
      };
      if (canUseThumbs) {
        mainGalleryOpts.asNavFor = thumbSelector;
      }
      main_slider.slick(mainGalleryOpts);

      if (canUseThumbs) {
        thumbnail_slider.slick({
          slidesToShow: thumbVisibleCount,
          slidesToScroll: 1,
          dots: false,
          arrows: false,
          centerMode: true,
          infinite: shouldLoopBase,
          prevArrow: $(".custom-slider-nav.slider-button--prev"),
          nextArrow: $(".custom-slider-nav.slider-button--next"),
          focusOnSelect: true,
          swipeToSlide: true,
          asNavFor: mainSelector,
        });
      }

      // Pick the correct predicate based on frame style
      var keepFn = isMiniFrameStyle(frameStyle) ? keepMini : keepNonMini;

      [main_slider, thumbnail_slider].forEach(function ($g) {
        if (!$g.hasClass("slick-initialized")) return;
        $g.slick("slickUnfilter");
        $g.slick("slickFilter", function (i, el) {
          return keepFn(el);
        });
      });

      var filteredSlideCount = main_slider.slick("getSlick")?.slideCount || 0;
      var shouldLoopFiltered = canUseThumbs && filteredSlideCount > thumbVisibleCount;
      main_slider.slick("slickSetOption", "infinite", shouldLoopFiltered, true);
      if (thumbnail_slider.hasClass("slick-initialized")) {
        thumbnail_slider.slick("slickSetOption", "infinite", shouldLoopFiltered, true);
      }

      main_slider.slick("slickGoTo", 0);
      if (thumbnail_slider.hasClass("slick-initialized")) {
        thumbnail_slider.slick("slickGoTo", 0);
      }
    }

    // Main ↔ thumbnail sync is handled by Slick asNavFor + focusOnSelect (see custom.js). Avoid binding
    // duplicate click/afterChange handlers here — they stacked on every variant change and fought asNavFor.

    setTimeout(() => {
      this.reapplyFrameStyling();
    }, 300);
  }

  reapplyFrameStyling() {
    const selectedFrameLabel = this.querySelector(".option-framing input:checked + label");

    if (!selectedFrameLabel) {
      $(".size-and-more-detail-tab-item-card").find(".size-and-more-img-wrap").css("background-image", "none");
      $(".main-product-gallery div:not(.other) .card__media").css("background-image", "none");
      $(".product-images-zoom-slider .card__media").css("background-image", "none");
      return;
    }

    const inputId = selectedFrameLabel.getAttribute("for");
    const frameInput = document.getElementById(inputId);

    if (!frameInput) {
      return;
    }

    const frameUrl = frameInput.getAttribute("data-url");
    const frameUrlNs = frameInput.getAttribute("data-url-ns");
    const frameUrlMini = frameInput.getAttribute("data-url-mini");

    if (!frameUrl) {
      $(".size-and-more-detail-tab-item-card").find(".size-and-more-img-wrap").css("background-image", "none");
      $(".main-product-gallery div:not(.other) .card__media").css("background-image", "none");
      $(".product-images-zoom-slider .card__media").css("background-image", "none");
      return;
    }

    const isMiniSelected = this.currentVariant && isMiniFrameStyle(this.currentVariant.option1);
    const mainProductCardUrl = isMiniSelected && frameUrlMini ? frameUrlMini : frameUrlNs;

    if ($(".main-product-gallery div:not(.other) .card__media").length > 1) {
      $(".size-and-more-detail-tab-item-card").find(".size-and-more-img-wrap").css("background-image", `url(${frameUrl})`);
      $(".main-product-gallery div:not(.other) .card__media.main_product_card_media").css(
        "background-image",
        `url(${mainProductCardUrl})`,
      );
      $(".main-product-gallery div:not(.other) .card__media.main_product_card_media:last-child").css(
        "background-image",
        `url(${isMiniSelected && frameUrlMini ? frameUrlMini : frameUrl})`,
      );
      $(".main-product-gallery div:not(.other) .card__media.wall_table_preview").css(
        "background-image",
        `url(${frameUrlNs})`,
      );
      $(".main-product-gallery div:not(.other) .card__media.wall_table_preview:last-child").css(
        "background-image",
        `url(${frameUrl})`,
      );
      $(".product-images-zoom-slider .card__media.main_product_card_media").css(
        "background-image",
        `url(${mainProductCardUrl})`,
      );
      $(".product-images-zoom-slider .card__media.main_product_card_media:last-child").css(
        "background-image",
        `url(${isMiniSelected && frameUrlMini ? frameUrlMini : frameUrl})`,
      );
      $(".product-images-zoom-slider .card__media.wall_table_preview").css("background-image", `url(${frameUrlNs})`);
      $(".product-images-zoom-slider .card__media.wall_table_preview:last-child").css(
        "background-image",
        `url(${frameUrl})`,
      );
      $(".mini-first-image .card__media.additional__card_media").css("background-image", `url(${frameUrl})`);

      $(".main-product-gallery .mini-first-image .card__media").css("background-image", `url(${frameUrlMini})`);
      $(".mini-image .size-compare-frame").css("background-image", `url(${frameUrlMini})`);
      $(".small-image .size-compare-frame").css("background-image", `url(${frameUrl})`);
    } else {
      $(".size-and-more-detail-tab-item-card").find(".size-and-more-img-wrap").css("background-image", `url(${frameUrl})`);
      $(".main-product-gallery div:not(.other) .card__media").css("background-image", `url(${frameUrl})`);
      $(".product-images-zoom-slider .card__media").css("background-image", `url(${frameUrl})`);
    }
  }

  updateColorSwatchSelectionAbility() {
    const glareInput = this.querySelector(".option-glare input");
    const sizeOptions = this.querySelectorAll("#product-select-print-size .input-label-wrap.option-input");
    if (shouldShowCollectorPremiumAcrylic(this, sizeOptions, this.currentVariant)) return;
    if (this.currentVariant.option1 == "No Frame") {
      this.querySelector(".product-form-flex.framing").classList.add("disable");
      if (glareInput && glareInput.checked) {
        glareInput.click();
      }
      glareInput.setAttribute("disabled", "true");
    } else {
      if (this.querySelector(".product-form-flex.framing")) {
        this.querySelector(".product-form-flex.framing").classList.remove("disable");
        glareInput.removeAttribute("disabled");
      }
    }
    if (this.currentVariant.option1 == "Shadow Box") {
      if (glareInput && glareInput.checked) {
        glareInput.click();
      }
    }
  }

  updateSelectedOptionValue() {
    const optionLabel = this.querySelector(".option-label .option-title");
    const has3Options = this.currentVariant && this.currentVariant.option3 ? true : false;
    if (this.currentVariant && optionLabel) {
      if (has3Options) {
        //const frameStyleLabel = this.querySelector('.frame-style .option-title');
        const frameColorLabel = this.querySelector(".frame-color .option-title .option-title-text");
        //frameStyleLabel.innerHTML = this.currentVariant.option1;
        frameColorLabel.innerHTML = this.currentVariant.option2;
      } else {
        optionLabel.innerHTML = this.currentVariant.option2;
      }
    }
  }

  updateVariantDisplayProperty() {
    const variantDisplay = document.getElementById("variant-display");
    if (!variantDisplay) return;

    const selectedSize = this.querySelector(".option-print-size input:checked + label .name")
      ?.textContent?.trim()
      .replace(/\s+/g, " ");

    const selectedFrame = this.querySelector(".option-framing input:checked + label + .option-title")
      ?.textContent?.trim()
      .replace(/\s+/g, " ");

    const sizePart = selectedSize || "";
    const framePart = selectedFrame || "";
    if (!sizePart && !framePart) return;

    variantDisplay.setAttribute("name", "properties[__variant_display]");
    variantDisplay.value = framePart ? `${sizePart}/${framePart}` : sizePart;
  }

  updateLineItemProperties() {
    const printOnlyVariantId =
      this.id === "variant-radios-cart-drawer" ? "print_only_variant_id-cart-drawer" : "print_only_variant_id";

    const printOnlyInput = printOnlyVariantId ? document.getElementById(printOnlyVariantId) : null;

    if (!printOnlyInput || !document.getElementById("variant-display")) return;

    if (this.currentVariant.option1 === "No Frame" && this.currentVariant.option2 === "No Frame") {
      printOnlyInput.setAttribute("name", "properties[__print_only_variant_id]");
      printOnlyInput.value = this.currentVariant.id;
    } else {
      printOnlyInput.value = "";
      printOnlyInput.removeAttribute("name");
    }
  }

  setSelectedOptions() {
    this.options = Array.from(this.querySelectorAll("select"), (select) => select.value);
  }

  setSelectedVariant() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });

    // If strict match fails, try a slightly looser match (ignoring case & trimming)
    if (!this.currentVariant && this.options.length) {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options
          .map((option, index) => {
            const val1 = (this.options[index] || "").toLowerCase().trim();
            const val2 = (option || "").toLowerCase().trim();
            // Handle cases where Anti-Glare was appended incorrectly or missing
            if (val1 === val2 || val1.replace(" anti-glare", "") === val2.replace(" anti-glare", "")) return true;
            // Handle cases where option is Mini but JSON says "Mini (11x14)"
            if (val1 === "mini" && val2.includes("mini")) return true;
            if (val2 === "mini" && val1.includes("mini")) return true;
            return false;
          })
          .includes(false);
      });
    }
  }

  // checkMasterId() {
  //   const framingOptionPos = document.getElementById('cb-framing_option_position');
  //   if (framingOptionPos !== null) {
  //     this.currentVariant = this.getVariantData().find((variant) => {
  //       return !variant.options
  //           .map((option, index) => {
  //             if (index+1 === parseInt(framingOptionPos.dataset.opt_pos)) {
  //               return this.options[index] + ' Anti-Glare' === option;
  //             } else {
  //               return this.options[index] === option;
  //             }
  //           })
  //           .includes(false);
  //     });

  //     if (this.currentVariant === undefined) {
  //       this.currentVariant = this.getVariantData().find((variant) => {
  //         return !variant.options
  //             .map((option, index) => {
  //               return this.options[index] === option;
  //             })
  //             .includes(false);
  //       });
  //     }
  //   }
  // }

  updateMedia() {
    if (!this.currentVariant) return;
    // mediaGalleries.forEach((mediaGallery) =>
    //   mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    // );
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true),
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      const inputName = productForm.querySelector('input[name="variant_name"]');
      const inputSku = productForm.querySelector('input[name="sku"]');
      const inputPrice = productForm.querySelector('input[name="price"]');
      input.value = this.currentVariant.id;
      inputName.value = this.currentVariant.title;
      inputSku.value = this.currentVariant.sku;
      inputPrice.value = this.currentVariant.price;
      input.dispatchEvent(new Event("change", {bubbles: true}));
    });
  }

  updateVariantStatuses() {
    const variants = this.getVariantData();
    if (!Array.isArray(variants) || !variants.length) return;

    const optionWrappers = [...this.querySelectorAll(".product-form__input")];
    if (!optionWrappers.length) return;

    const getSelectedValueFromWrapper = (wrapper) => {
      const checkedRadio = wrapper.querySelector('input[type="radio"]:checked');
      if (checkedRadio) return checkedRadio.value;
      const selectEl = wrapper.querySelector("select");
      if (selectEl) return selectEl.value;
      const selectedOption = wrapper.querySelector("option:checked");
      if (selectedOption) return selectedOption.value;
      return null;
    };

    const selectedValues = optionWrappers.map(getSelectedValueFromWrapper);

    const matchesPrefix = (variant, endExclusive) => {
      const opts = Array.isArray(variant.options) ? variant.options : [];
      for (let i = 0; i < endExclusive; i++) {
        const selected = selectedValues[i];
        if (selected == null) return false;
        if (opts[i] !== selected) return false;
      }
      return true;
    };

    let correctionTarget = null;

    optionWrappers.forEach((wrapper, index) => {
      const optionInputs = [...wrapper.querySelectorAll('input[type="radio"]')];
      const optionEls = optionInputs.length ? optionInputs : [...wrapper.querySelectorAll("select option")];

      if (!optionEls.length) return;

      const availableValues = Array.from(
        new Set(
          variants
            .filter((v) => v && v.available)
            .filter((v) => (index === 0 ? true : matchesPrefix(v, index)))
            .map((v) => (Array.isArray(v.options) ? v.options[index] : null))
            .filter((v) => v != null),
        ),
      );

      this.setInputAvailability(optionEls, availableValues);

      // If the currently-selected value just became unavailable, auto-select the
      // first available value so we never strand the user on a missing combination.
      if (correctionTarget) return;

      if (optionInputs.length) {
        const checked = wrapper.querySelector('input[type="radio"]:checked');
        const checkedIsUnavailable =
          !checked ||
          checked.disabled ||
          checked.classList.contains("disabled") ||
          checked.getAttribute("aria-disabled") === "true";

        if (checkedIsUnavailable) {
          const fallback = wrapper.querySelector('input[type="radio"]:not([disabled]):not(.disabled)');
          if (fallback && fallback !== checked) {
            fallback.checked = true;
            correctionTarget = fallback;
          }
        }
      } else {
        const select = wrapper.querySelector("select");
        if (select) {
          const selectedOpt = select.selectedOptions?.[0] || null;
          const selectedIsUnavailable = !selectedOpt || selectedOpt.disabled || selectedOpt.hidden;

          if (selectedIsUnavailable) {
            const fallbackOpt = select.querySelector("option:not([disabled]):not([hidden])");
            if (fallbackOpt) {
              select.value = fallbackOpt.value;
              correctionTarget = select;
            }
          }
        }
      }
    });

    if (correctionTarget) {
      correctionTarget.dispatchEvent(new Event("change", {bubbles: true}));
    }
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((el) => {
      const value = el.getAttribute("value");
      if (value == null) return;

      // Keep placeholder options (e.g. gift card "Select Amount") visible.
      if (value === "") return;

      const isAvailable = listOfAvailableOptions.includes(value);

      // <option> (variant-selects) handling
      if (el.tagName === "OPTION") {
        el.disabled = !isAvailable;
        el.hidden = !isAvailable;

        if (!isAvailable && el.selected) {
          const select = el.closest("select");
          const fallback = select?.querySelector("option:not([disabled]):not([hidden])");
          if (fallback) fallback.selected = true;
        }
        return;
      }

      // <input type="radio"> (variant-radios base implementation)
      el.classList.toggle("disabled", !isAvailable);
      el.toggleAttribute("disabled", !isAvailable);
      el.disabled = !isAvailable;
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    // document.querySelectorAll('.js-cb-framing-swatch-container label').forEach(function (el) {
    //   el.classList.remove('pseudo-checked-swatch');
    // });

    // Preserve the visible (non-AG) swatch highlight when Anti-Glare is ON.
    const agId = this.dataset.section === "cart-drawer" ? "anti-glare-cart-drawer" : "anti-glare";
    const antiGlareOn = document.getElementById(agId)?.checked;

    // Always clear first
    document
      .querySelectorAll(".js-cb-framing-swatch-container label")
      .forEach((el) => el.classList.remove("pseudo-checked-swatch"));

    if (antiGlareOn) {
      // Determine which radio group name is present on this product
      const group = this.querySelector('input[type="radio"][name="Frame Color"]')
        ? "Frame Color"
        : this.querySelector('input[type="radio"][name="Framing"]')
          ? "Framing"
          : null;

      if (group) {
        // The checked input might be the hidden “Anti-Glare” twin; normalize to the base value
        const checked = this.querySelector(`input[type="radio"][name="${group}"]:checked`);
        const baseVal = checked?.value?.replace(/ Anti-Glare$/, "");
        if (baseVal) {
          // Find the visible non-AG swatch with the same base value and re-apply the pseudo class
          const visible = this.querySelector(
            `.js-cb-framing-swatch-container input[type="radio"][name="${group}"][value="${baseVal}"]`,
          );
          if (visible && visible.nextElementSibling) {
            visible.nextElementSibling.classList.add("pseudo-checked-swatch");
          }
        }
      }
    }

    let fetchUrl = `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
      this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
    }`;

    if (this.dataset.section === "cart-drawer") {
      fetchUrl = `${this.dataset.url}?variant=${requestedVariantId}&view=cart-upsell`;
    }

    fetch(fetchUrl)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");

        const destination = document.getElementsByClassName(`price-${this.dataset.section}`);
        // const source = html.getElementsByClassName(
        //   `price-${this.dataset.section}`
        // );
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove("hidden");
        if (volumePricingDestination) volumePricingDestination.classList.remove("hidden");
        if (qtyRules) qtyRules.classList.remove("hidden");

        if (source && destination.length > 0) {
          for (let i = 0; i < destination.length; i++) {
            destination[i].innerHTML = source.innerHTML;
          }
        }

        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle("hidden", skuSource.classList.contains("hidden"));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle("hidden", pricePerItemSource.classList.contains("hidden"));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) price.classList.remove("hidden");

        const priceValHtml = html.querySelector(".product-form__submit .cb-current-price")?.innerHTML;
        const priceValText = html.querySelector(".product-form__submit .cb-current-price")?.innerText;
        // console.log('cdebug priceval', priceValHtml);
        const priceValDestination = document
          .querySelector(`[data-section="${this.dataset.section}"]`)
          .querySelector(".cb-current-price");
        if (priceValHtml && priceValDestination) priceValDestination.innerHTML = priceValHtml;
        // Updates wholesale price line item property
        if (priceValText && document.getElementById("wholesale_price"))
          document.getElementById("wholesale_price").value = priceValText.trim();

        const designTipDestination = document.getElementById(`design-tip-${this.dataset.section}`);
        const designTipSource = html.getElementById(
          `design-tip-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
        );
        if (designTipSource && designTipDestination) {
          designTipDestination.innerHTML = designTipSource.innerHTML;
          designTipDestination.classList.toggle("hidden", designTipSource.classList.contains("hidden"));
        }

        const glarePriceDestination = document.getElementById(`glare-price-${this.dataset.section}`);
        const glarePriceSource = html.getElementById(
          `glare-price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
        );
        if (glarePriceSource && glarePriceDestination) {
          glarePriceDestination.innerHTML = glarePriceSource.innerHTML;
          glarePriceDestination.classList.toggle("hidden", glarePriceSource.classList.contains("hidden"));
        }

        // const antiGlareDestination = document.getElementById(`anti-glare`);
        // const antiGlareSource = html.getElementById(`anti-glare`);
        // if (antiGlareSource && antiGlareDestination) {
        //   if (antiGlareSource.hasAttribute('disabled'))
        //     antiGlareDestination.setAttribute('disabled', "true");
        //   else
        //     antiGlareDestination.removeAttribute('disabled');

        //   if (antiGlareSource.hasAttribute('checked')) {
        //     antiGlareDestination.setAttribute('checked', "true");
        //     $('#anti-glare').attr('checked', "true");
        //     $('#anti-glare').prop('checked', true);

        //   } else {
        //     antiGlareDestination.removeAttribute('checked');
        //     $('#anti-glare').removeAttr('checked');
        //     $('#anti-glare').prop('checked', false);
        //   }
        // }

        // if(this.dataset.section === 'cart-drawer') {
        //   const antiGlareDestination = document.getElementById(`anti-glare-cart-drawer`);
        //   const antiGlareSource = html.getElementById(`anti-glare-cart-drawer`);
        //   if (antiGlareSource && antiGlareDestination) {
        //     if (antiGlareSource.hasAttribute('disabled'))
        //       antiGlareDestination.setAttribute('disabled', "true");
        //     else
        //       antiGlareDestination.removeAttribute('disabled');

        //     if (antiGlareSource.hasAttribute('checked')) {
        //       antiGlareDestination.setAttribute('checked', "true");
        //       $('#anti-glare-cart-drawer').attr('checked', "true");
        //       $('#anti-glare-cart-drawer').prop('checked', true);

        //     } else {
        //       antiGlareDestination.removeAttribute('checked');
        //       $('#anti-glare-cart-drawer').removeAttr('checked');
        //       $('#anti-glare-cart-drawer').prop('checked', false);
        //     }
        //   }
        // }

        const noFramePriceInput = this.dataset.section == "cart-drawer" ? "no_frame_price_drawer" : "no_frame_price";

        const noFramePriceDestination = document.querySelector(
          `[data-section="${this.dataset.section}"] #${noFramePriceInput}`,
        );
        const noFramePriceSource = html.getElementById(noFramePriceInput);
        if (noFramePriceDestination && noFramePriceSource) {
          noFramePriceDestination.value = noFramePriceSource.value;
        }
        // Override: anti-glare checked = use No Frame Anti-Glare price; unchecked = keep no-frame price
        const agEl = document.getElementById(agId);
        if (noFramePriceDestination && agEl && this.currentVariant) {
          try {
            const vs = this.getVariantData();
            const cur = this.currentVariant;
            const ok = (v) => String(v.option3 || "") === String(cur.option3 || "");
            const noFrame = vs.find((v) => v.option1 === cur.option1 && v.option2 === "No Frame" && ok(v));
            const noFrameAG =
              agEl.checked && cur.option1 === "Premium Archival"
                ? vs.find((v) => v.option1 === "Premium Archival" && v.option2 === "No Frame Anti-Glare" && ok(v))
                : null;
            if (noFrameAG) noFramePriceDestination.value = noFrameAG.price;
            else if (noFrame) noFramePriceDestination.value = noFrame.price;
          } catch (e) {}
        }

        const cartUpdateBtnDestination = document.getElementsByClassName(`cart-update-product-btn`);
        const cartUpdateBtnSource = html.getElementsByClassName(`cart-update-product-btn`);
        if (
          cartUpdateBtnSource.length > 0 &&
          cartUpdateBtnDestination.length > 0 &&
          cartUpdateBtnSource.length === cartUpdateBtnDestination.length
        ) {
          for (let i = 0; i < cartUpdateBtnDestination.length; i++) {
            cartUpdateBtnDestination[i].dataset.current_var_id = cartUpdateBtnSource[i].dataset.current_var_id;
          }
        }

        const optionLabelsDestination = document.querySelectorAll(`legend.form__label`);
        const optionLabelsSource = html.querySelectorAll(`legend.form__label`);
        if (
          optionLabelsSource.length > 0 &&
          optionLabelsDestination.length > 0 &&
          optionLabelsSource.length === optionLabelsDestination.length
        ) {
          for (let i = 0; i < optionLabelsDestination.length; i++) {
            optionLabelsDestination[i].innerHTML = optionLabelsSource[i].innerHTML;
          }
        }

        let sizePricesDestination;
        if (this.dataset.section === "cart-drawer") {
          sizePricesDestination = document.querySelector(".drawer__upsell-main").getElementsByClassName(`frame-option`);
          console.log("cart drawer price update");
        } else {
          sizePricesDestination = document.querySelector("product-info").getElementsByClassName(`frame-option`);
        }
        const sizePricesSource = html.getElementsByClassName(`frame-option`);
        if (
          sizePricesSource.length > 0 &&
          sizePricesDestination.length > 0 &&
          sizePricesSource.length === sizePricesDestination.length
        ) {
          for (let i = 0; i < sizePricesDestination.length; i++) {
            sizePricesDestination[i].innerHTML = sizePricesSource[i].innerHTML;
            sizePricesDestination[i].classList.toggle("hidden", sizePricesSource[i].classList.contains("hidden"));
          }
          this.reinitHints();
        }

        if (inventoryDestination) inventoryDestination.classList.toggle("hidden", inventorySource.innerText === "");

        const addButtonUpdated = html.querySelector(".product-form__submit");
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          window.variantStrings.soldOut,
        );

        // Update compare at price line item property
        if (document.getElementById("compare_price")) {
          const comparePriceProperty = document.getElementById("compare_price");
          const originalPrice = JSON.parse(
            html.querySelector("s.price-item--regular").textContent.replace("$", "").replace(",", ""),
          );
          const finalPrice = JSON.parse(
            html.querySelector(".price__sale .price-item--sale").textContent.replace("NOW $", "").replace(",", ""),
          );

          if (originalPrice > finalPrice) {
            comparePriceProperty.setAttribute("name", "properties[Free Framing]");
            comparePriceProperty.value = `Original Price $${originalPrice.toLocaleString()}`;
          } else {
            comparePriceProperty.value = "";
            comparePriceProperty.removeAttribute("name");
          }
        }

        // --- REPLACE GALLERIES & REINIT SLICK (defensive) ---
        if (document.body.classList.contains("template-alternate") && !document.body.classList.contains("clothing")) {
          // Look up DEST (live page) nodes
          const destWrapper = document.querySelector(".product__media-wrapper");
          const destMain = destWrapper?.querySelector(".main-product-gallery");
          const destThumbs = destWrapper?.querySelector(".main-thubnails");

          // Look up SRC (HTML response) nodes
          const srcWrapper = html.querySelector(".product__media-wrapper");
          const srcMain = srcWrapper?.querySelector(".main-product-gallery");
          const srcThumbs = srcWrapper?.querySelector(".main-thubnails");

          // Diagnostics
          if (!destWrapper) {
            console.warn("[gallery] Dest wrapper not found");
          }
          if (!srcWrapper) {
            console.warn("[gallery] Src wrapper not found in fetched HTML");
          }
          if (!destMain) {
            console.warn("[gallery] Dest main gallery not found");
          }
          if (!srcMain) {
            console.warn("[gallery] Src main gallery not found");
          }
          if (!destThumbs) {
            console.warn("[gallery] Dest thumbs not found");
          }
          if (!srcThumbs) {
            console.warn("[gallery] Src thumbs not found");
          }

          // Abort if critical pieces are missing
          if (!destWrapper || !srcWrapper || !destMain || !srcMain) {
            // We need at least wrapper + main gallery to proceed
            return;
          }

          // 1) Unslick existing instances (if present)
          try {
            if ($(destMain).hasClass("slick-initialized")) $(destMain).slick("unslick");
          } catch (e) {
            console.debug("[gallery] main unslick skipped", e);
          }
          if (destThumbs) {
            try {
              if ($(destThumbs).hasClass("slick-initialized")) $(destThumbs).slick("unslick");
            } catch (e) {
              console.debug("[gallery] thumbs unslick skipped", e);
            }
          }

          // 2) Replace MAIN gallery node
          const newMain = srcMain.cloneNode(true);
          destMain.replaceWith(newMain);

          // 3) Replace THUMBS node if both exist
          let newThumbsEl = null;
          if (destThumbs && srcThumbs) {
            newThumbsEl = srcThumbs.cloneNode(true);
            destThumbs.replaceWith(newThumbsEl);
          }

          // 4) Re-init Slick (idempotent)
          const $main = $(".product__media-wrapper .main-product-gallery");
          const $thumbs = $(".product__media-wrapper .main-thubnails");
          const isMobileGallery = window.matchMedia("(max-width: 767px)").matches;
          const thumbVisibleCount = 7;
          const shouldLoopGallery = $thumbs.length && $thumbs.children().length > thumbVisibleCount;

          if ($main.length) {
            var mainGalleryOpts = {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: true,
              fade: false,
              dots: true,
              infinite: shouldLoopGallery,
              responsive: [
                {
                  breakpoint: 767,
                  settings: {slidesToShow: 1, dots: true, arrows: false},
                },
              ],
            };
            if (!isMobileGallery && $thumbs.length) {
              mainGalleryOpts.asNavFor = ".product__media-wrapper .main-thubnails";
            }
            $main.slick(mainGalleryOpts);
          }

          if ($thumbs.length && !isMobileGallery) {
            $thumbs.slick({
              slidesToShow: 7,
              slidesToScroll: 1,
              dots: false,
              arrows: false,
              centerMode: true,
              infinite: shouldLoopGallery,
              prevArrow: $(".custom-slider-nav.slider-button--prev"),
              nextArrow: $(".custom-slider-nav.slider-button--next"),
              focusOnSelect: true,
              swipeToSlide: true,
              asNavFor: ".product__media-wrapper .main-product-gallery",
            });
          }
        }

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  reinitHints() {
    $(".hint-description").appendTo("body");

    $(".hint-block .hint").on({
      mouseenter: function () {
        var dataHint = $(this).data("hint");
        var mouseX = 0,
          mouseY = 0;
        var xp = 0,
          yp = 0;

        $(this).mousemove(function (e) {
          mouseX = e.pageX;
          mouseY = e.pageY;

          $(".hint-description").each(function () {
            if ($(this).data("hint-desc") == dataHint) {
              $(this).addClass("hint-hovered");
              if ($(this).hasClass("hint-hovered")) {
                $(this).css({
                  top: mouseY + 20 + "px",
                  left: mouseX - $(this).outerWidth() + 30 + "px",
                });
                var pos = $(this).position(),
                  posX = pos.left;
                if (posX < 0 || posX == 15) {
                  $(this).css("left", "15px");
                }
              } else {
                $(this).removeClass("hint-hovered");
              }
            }
          });
        });
      },
      mouseleave: function () {
        $(".hint-description").removeClass("hint-hovered");
      },
    });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);

    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      if (!addButton.classList.contains("no-size-selected-yet")) {
        addButton.removeAttribute("disabled");
        addButtonText.textContent = window.variantStrings.addToCart;
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    //addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("hidden");
    if (inventory) inventory.classList.add("hidden");
    if (sku) sku.classList.add("hidden");
    if (pricePerItem) pricePerItem.classList.add("hidden");
    if (volumeNote) volumeNote.classList.add("hidden");
    if (volumeTable) volumeTable.classList.add("hidden");
    if (qtyRules) qtyRules.classList.add("hidden");
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      const value = input.getAttribute("value");
      if (value == null) return;

      const isAvailable = listOfAvailableOptions.includes(value);

      const colorSwatchWrapper = input.closest(".color-swatch") || input.closest(".js-cb-framing-swatch-container");

      const wrapper = colorSwatchWrapper || input.closest(".input-label-wrap") || input.parentElement;

      input.classList.toggle("disabled", !isAvailable);
      input.toggleAttribute("disabled", !isAvailable);
      input.disabled = !isAvailable;

      if (wrapper) {
        // Frame color swatches: toggle disabled only on the input so label opacity
        // matches the rest of the site (avoid .disabled on the wrapper compounding dimming).
        if (!colorSwatchWrapper) {
          wrapper.classList.toggle("disabled", !isAvailable);
        }
        // Keep color swatches visible but disabled; only hide non-swatch options
        if (!colorSwatchWrapper) {
          wrapper.style.display = isAvailable ? "" : "none";
          wrapper.toggleAttribute("hidden", !isAvailable);
        }
      }
    });
  }

  setSelectedOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      const checkValRadio = Array.from(fieldset.querySelectorAll("input")).find((radio) => radio.checked);
      const checkVal = checkValRadio ? checkValRadio.value : null;
      const antiGlareDestination = document.getElementById(`anti-glare`);
      if (antiGlareDestination) {
        if (antiGlareDestination.hasAttribute("checked")) {
          const checkValEl = document.querySelector(
            'input[type="radio"][name="Framing"][value="' + checkVal.replace(/"/g, '\\"') + " Anti-Glare" + '"]',
          );

          if (checkValEl !== null) {
            return checkVal + " Anti-Glare";
          } else {
            return checkVal;
          }
        } else {
          return checkVal;
        }
      } else {
        return checkVal;
      }
      // return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector("slideshow-component") && this.classList.contains("complementary-products")) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("product-recommendations", ProductRecommendations);
